<template>
    <div>
        <!-- dialog -->
        <v-dialog v-model="dialog" persistent @keydown.esc="dialog = false" width="600">
            <v-card>
                <div class="d-flex py-1 primary">
                    <v-card-title
                        class="text-uppercase flex-grow-1 text-subtitle-1 justify-center pa-0 white--text"
                    >
                        {{ $t('DebtRecordVisit.modify-amount-received')}}
                    </v-card-title>

                    <v-btn icon @click="dialog = false">
                        <v-icon color="white"> mdi-close-circle-outline </v-icon>
                    </v-btn>
                </div>
                <v-form ref="form" @submit.prevent="submit">
                    <v-card-text class="">
                        <v-row>
                            <v-col cols="auto" md="4" xl="2" class="pb-0 pe-1">
                                <div
                                    style="background-color: #0b5b6f0f; width: 100%; height: 34px"
                                    class="px-2 rounded-lg d-flex justify-center align-center"
                                >
                                    <h6 class=" mb-0 " style="font-size: 12px">
                                        {{ $t('inputs.total') }}
                                    </h6>
                                    <span class="mx-auto font-weight-bold success--text headline pb-0 mb-0 pb-0 " style="" > 
                                        {{ total }}
                                    </span>
                                </div>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field
                                    ref="amountReceivedField"
                                    v-model.number="amountReceived"
                                    :label="$t('inputs.amount-received')"
                                    type="number"
                                    min="0"
                                    dense
                                    hide-spin-buttons
                                    hide-details="auto"
                                    outlined
                                    autofocus
                                    :disabled="submitLoading"
                                    class="rounded-lg"
                                    background-color="#0b5b6f0f"
                                    :rules="[val => val <= total]"
                                    @input="remaining = visit.amountReceived ? (total - visit?.amountReceived) - amountReceived : total - amountReceived"
                                />
                            </v-col>

                            <v-col cols="auto" md="4" xl="2" class="pb-0 ps-1">
                                <div
                                    style="background-color: #0b5b6f0f; width: 100%; height: 34px"
                                    class="px-2 rounded-lg d-flex  align-center"
                                >
                                    <h6 class="mb-0" style="font-size: 12px">
                                        {{ $t('inputs.remaining') }}
                                    </h6>
                                    <span class="mx-auto font-weight-bold alert-color--text headline pb-0 mb-0 pb-0 " style="" > 
                                        {{ remaining }}
                                    </span>   
                                </div>
                            </v-col>

                            <v-col cols="12" class="pt-0">
                                <bee-handy-table
                                    :items="itemsDialog"
                                    :headers="headersDialog"
                                    :data-table-props="{
                                        disableSort: true
                                    }"
                                    dense
                                    zebra
                                    hide-default-footer
                                >
                                    <template v-slot:item.freeSample="{ item }">
                                        <v-chip small>
                                            <span :class="item.freeSample === true ? 'primary--text' : 'paid-color-text'">
                                                {{ item.freeSample === true ? 'Free' : 'Paid' }}
                                            </span>
                                        </v-chip>
                                    </template>

                                    <template v-slot:item.total="{ item }">
                                        <div>
                                            {{ item.priceDiscount === 0 ? item.amount * item.sellPrice : (item.amount * item.sellPrice) - (item.amount * item.sellPrice) * (item.priceDiscount / 100) }}
                                        </div>
                                    </template>
                                </bee-handy-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn 
                            color="success" 
                            text 
                            type="submit" 
                            :loading="submitLoading" 
                            :disabled="submitLoading" 
                        >
                            {{$t('save')}}
                        </v-btn>
                        <v-btn
                            color="grey darken-1"
                            text
                            @click="dialog = false"
                            :disabled="submitLoading"
                        >
                            {{$t('close')}}
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- filter --> 
        <v-row class="align-center ma-1 mt-2">
            <!-- city region filter -->
            <v-col lg="4" md="5" sm="8" cols="12" class="pa-1">
                <v-row class="justify-space-between ma-0">
                    <!-- city name -->
                    <v-col
                        md="5"
                        sm="4"
                        cols="6"
                        class="py-0"
                        :class="{ 
                            'pe-1': $i18n.locale === 'en',
                            'ps-1': $i18n.locale === 'ar'
                        }"
                    >
                        <v-autocomplete
                            v-model="cityId"
                            :items="cities"
                            item-text="name"
                            item-value="id"
                            :label="$t('inputs.city')"
                            dense
                            prepend-icon="mdi-map-marker-multiple"
                            hide-details
                            append-icon
                            multiple
                            clearable
                            :disabled="loading"
                            :search-input.sync="searchCityId"
                            @change="setRegions(); searchCityId = null"
                            outlined
                        >
                            <template v-slot:prepend-item>
                                <v-list-item
                                    ripple
                                    @click="toggleCities"
                                >
                                    <v-list-item-action>
                                        <v-icon>
                                            {{ iconCities }}
                                        </v-icon>
                                    </v-list-item-action>
                                    
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{ $t('select-all') }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>

                            <template v-slot:selection="{ item, index }">
                                <span v-if="index === 0" class="me-1">{{ item.name }}</span>
                                <span
                                    v-if="index === 1"
                                    class="grey--text text-caption"
                                >
                                    (+{{ cityId.length - 1 }})
                                </span>
                            </template>
                        </v-autocomplete>
                    </v-col>
        
                    <!-- region -->
                    <v-col md="7" sm="8" cols="6" class="pa-0">
                        <v-autocomplete
                            v-model="regionIds"
                            :items="regionsAll.filter(c => cityId.includes(c.cityId)).sort(function(a, b) { if(a.name < b.name) {return -1}; if(a.name > b.name) { return 1 }; return 0 })"
                            item-text="name"
                            item-value="id"
                            :label="!managementHierarchyRegions ? $t('inputs.region') : $t('inputs.area')"
                            dense
                            multiple
                            clearable
                            hide-details
                            append-icon
                            :disabled="loading || cityId === []"
                            outlined
                            :search-input.sync="searchRegion"
                            append-outer-icon="mdi-select-search"
                            @click:append-outer="getMedical()"
                        >
                            <!-- customerType !== null ? getEntityForType(customerType) : null -->
                            <template v-slot:selection="{ item, index }">
                                <span v-if="index === 0" class="me-1">{{ item.name }}</span>
                                <span
                                    v-if="index === 1"
                                    class="grey--text text-caption"
                                >
                                    (+{{ regionIds.length - 1 }})
                                </span>
                            </template>

                            <template v-slot:prepend-item>
                                <v-list-item ripple @click="toggle">
                                    <v-list-item-action>
                                        <v-icon>
                                            {{ icon }}
                                        </v-icon>
                                    </v-list-item-action>
                                    
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{ $t('select-all') }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                        </v-autocomplete>
                    </v-col>
                </v-row>
            </v-col>

            <!-- medical rep name -->
            <v-col md="2" sm="4" cols="12" class="pa-1 d-flex align-start">
                <v-autocomplete
                    v-model="employeeId"
                    :items="regionIds.length === 0 ? medicalRepsBrief : medicalRepsForRegion"
                    item-text="name"
                    item-value="id"
                    :label="$t('inputs.employees')"
                    prepend-icon="mdi-account-tie"
                    hide-details
                    clearable
                    :loading="filterLoading || loadingMedicalForRegion"
                    :disabled="loading"
                    outlined
                    dense
                >
                </v-autocomplete>
            </v-col>

            <v-divider vertical class="my-3 mx-1 grey"/>

            <v-col cols="auto" class="pa-0">
                <v-radio-group
                    v-model.number="dateType"
                    row
                    class="mt-1"
                    hide-details
                    :disabled="loading"
                >
                    <v-radio
                        :label="$t('daily-date')"
                        :value="1"
                    ></v-radio>
                    <v-radio
                        :label="$t('period')"
                        :value="2"
                    ></v-radio>
                </v-radio-group>
            </v-col>

            <v-col v-if="dateType === 2" cols="6" sm="3" md="2" class="pa-1">
                <bee-date-picker
                    v-model="startDate"
                    :input-label="$t('inputs.start-date')"
                    menu-picker
                    dense
                    hide-details
                    :input-props="{
                        outlined: true,
                        dense: true,
                        clearable: true
                    }"
                    :allowed-dates="disableDates"
                    :disabled="loading"
                ></bee-date-picker>
            </v-col>

            <!-- end date -->
            <v-col v-if="dateType === 2" cols="6" sm="3" md="2" class="pa-1">
                <bee-date-picker
                    v-model="endDate"
                    :input-label="$t('inputs.end-date')"
                    menu-picker
                    dense
                    hide-details
                    :input-props="{
                        outlined: true,
                        dense: true,
                        clearable: true
                    }"
                    :allowed-dates="disableDates"
                    :disabled="loading"
                ></bee-date-picker>
            </v-col>
            <!-- filter -->
            <v-col v-if="dateType === 1" cols="12" sm="6" md="3" class="pa-1">
                <bee-date-input
                    v-model="date"
                    :append-icon="$i18n.locale === 'en' ? 'mdi-menu-right' : 'mdi-menu-left' "
                    :prepend-icon="$i18n.locale === 'en' ? 'mdi-menu-left' : 'mdi-menu-right' "
                    :label="$t('inputs.date')"
                    input-format-order="DD-MM-YYYY"
                    dense
                    :loading="loading"
                    hide-details
                    @click:append="
                        addDate();
                        isFiltered = true;
                        needToRestShownItems = true;
                        filter()
                    "
                    @click:prepend="
                        subDate();
                        isFiltered = true
                        needToRestShownItems = true;
                        filter()
                    "
                    :disabled="loading"
                ></bee-date-input>
            </v-col>
        
            <v-divider vertical class="my-3 grey"/>
            <!-- name of all -->
            <v-col md="2" sm="4" cols="12" class="pa-1 d-flex align-start">
                <v-autocomplete
                    v-model="entityTypeId"
                    :items="customersTypes"
                    item-text="name"
                    item-value="id"
                    dense
                    hide-details
                    clearable
                    :label="$t('inputs.customer-type')"
                    :disabled="loading || entityLoading"
                    :loading="entityLoading"
                    outlined
                    prepend-icon="mdi-doctor"
                    @change="getEntityByType()"
                ></v-autocomplete>
            </v-col>
            <v-col md="2" sm="4" cols="12" class="pa-1 d-flex align-start">
                <v-autocomplete
                    v-model="entityIds"
                    :items="customersFilter"
                    item-text="name"
                    item-value="id"
                    dense
                    hide-details
                    clearable
                    :label="$t('inputs.customer')"
                    :disabled="loading || entityLoading || customersFilter.length === 0"
                    :loading="entityLoading"
                    outlined
                    multiple
                >
                    <template v-slot:selection="data">
                        <span
                            v-if="data.index === 0"
                        >                            
                            {{'  ' + data.item.name + '  ' }}
                        </span>

                        <span
                            v-if="data.index === 1"
                        >
                            (+{{ entityIds.length - 1 }})
                        </span>
                    </template>
                </v-autocomplete>
            </v-col>
            <v-spacer />
        
            <!-- search button -->
            <v-col cols="auto" class="pa-1">
                <v-btn
                    color="success"
                    class="px-sm-4 mx-2"
                    :loading="loading"
                    :disabled="loading"
                    small
                    @click="isFiltered = true; needToRestShownItems = true; filter()"
                >
                    <v-icon class="me-1"> mdi-magnify </v-icon>
                    {{$t('search')}}
                </v-btn>
        
                <v-btn
                    class="px-sm-8"
                    :disabled="loading || !isFiltered"
                    color="alert-color white--text"
                    small
                    @click="clearFilter()"
                >
                    {{ $t('reset') }}
                </v-btn>

                <v-divider vertical class="mx-2" style="height: 24px"/>
                <!-- Back to -->
                <v-btn
                    small
                    color="grey white--text"
                    :disabled="loading"
                >
                    <v-icon small class="me-1"> mdi-arrow-left-circle </v-icon>
                    {{$t('back')}}
                </v-btn>
            </v-col>
        </v-row>

        <!-- table -->
        <bee-handy-table
            ref="table"
            :items="[]"
            :headers="headers"
            dense
            zebra
            hide-default-footer
            pagination-on-scroll
            :pagination-on-scroll-auto-reset-shown="false"
            pagination-on-scroll-server-items
            :items-per-page="20"
            :scroll-options.sync="scrollOptions"
            :server-items-length="serverItemsLength"
            @pagination-on-scroll:reach-last-row="filter"
            :shown-rows-text="$t('shown-rows')"
            :loading="loading"
            :height="$vuetify.breakpoint.height - 210"
        >

            <template v-slot:item.remaining="{ item }">
                <div>
                    {{ 
                      
                        item.materialAmounts.map(c => 
                            c.priceDiscount === 0 
                            ? c.amount * c.sellPrice 
                            : (c.amount * c.sellPrice) - (c.amount * c.sellPrice) * (c.priceDiscount / 100)).reduce((a, b) => a + b, 0)
                        - item.amountReceived
                    }}
                </div>
            </template>
            <template v-slot:item.action="{ item }">
                <tooltip :text="$t('edit')" top>
                    <v-btn
                        icon
                        small
                        color="success"
                        class="me-2"
                        @click="visit = item; dialog = true"
                    >
                        <v-icon>mdi-plus-circle </v-icon>
                    </v-btn>
                </tooltip>
            </template>
        </bee-handy-table>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { managementHierarchyRegions, enableVacations, isDisabledFriday, addPrice } from '@/configs/global.config'
import { disableDates } from '@/helpers/functions'
import { userType } from '@/helpers/enums'
import moment from 'moment';
import Tooltip from '@/components/Tooltip.vue'
export default {
    name: 'DebtRecordVisits',

    components: {
        Tooltip
    },

    data () {
        return {
            cityId: [],
            searchCityId: null,
            regionIds: [],
            dateType: 1,
            startDate: moment().startOf('month').format('YYYY-MM-DD'),
            endDate: moment().endOf('month').format('YYYY-MM-DD'),
            date: moment().format('YYYY-MM-DD'),
            employeeId: null,
            
            medicalRepsForRegion: [],
            medicalRepIds: [],

            managementHierarchyRegions,
            enableVacations,
            isDisabledFriday,
            
            userType,
            
            loadingMedicalForRegion: false,
            loading: false,
            filterLoading: false,
            entityIds: [],
            searchRegion: null,

            scrollOptions: {},
            serverItemsLength: 0,
            needToRestShownItems: false,

            visit: null,

            dialog: false,

            amountReceived: 0,
            total: 0,
            itemsDialog: [],
            submitLoading: false,
            entityLoading: false,
            customersFilter: [],
            entityTypeId: null,
            isFiltered: false,
            remaining: 0,
            addPrice
        }
    }, 
    
    watch: {
        dialog (val) {
            if (val) {
                this.itemsDialog = this.visit?.materialAmounts || [];
                // this.amountReceived = this.visit?.amountReceived
                if (this.visit?.materialAmounts.length) {
                    const totalForRaw = this.visit?.materialAmounts.map(c => ({
                        ...c,
                        total: c.priceDiscount === 0 ? c.amount * c.sellPrice : (c.amount * c.sellPrice) - (c.amount * c.sellPrice * c.priceDiscount / 100)
                    }))
                    this.total = totalForRaw.reduce((acc, cur) => acc + cur.total, 0);
                }
                this.remaining = this.total - this.visit?.amountReceived
            } else {
                this.visit = null
                this.amountReceived = 0
            }
        }
    },

    computed: {
        ...mapState({
            cities: state => state.cities.cities,
            regionsAll: state => state.regions.regionsAll,
            vacationsDayDetails: state => state.vacations.vacationsDayDetails,
            medicalRepsBrief: state => state.medicalreps.medicalRepsBrief,
            materialBrief: state => state.materials.materialBrief,
            staff: state => state.accounts.staff,
            customersTypes: state => state.entityType.customersTypes
        }),

        ...mapGetters({
            getMaterialBriefById: 'materials/getMaterialBriefById'
        }),

        selectedAllCities () {
            return this.cityId.length === this.cities.length;
        },
        iconCities () {
            if (this.selectedAllCities) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        },

        selectedAllRegions () {
            return this.regionIds.length === this.regionsAll.filter(c => this.cityId?.includes(c.cityId)).length;
        },

        icon() {
            if (this.selectedAllRegions) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        },

        headers () {
            const headers = [
                {
                    text: this.$t('headers.entity-name'),
                    name: 'entityName',
                    value: 'entityName',
                },

                {
                    text: this.$t('headers.employee-name'),
                    name: 'employeeId',
                    value: 'employeeId',
                    setValueExpr: val => this.staff.find(c => c.id === val)?.name || '',
                },

                {
                    text: this.$t('headers.total-amount'),
                    name: 'total',
                    value: 'materialAmounts',
                    setValueExpr: val => {
                        const total = val.map(c => c.priceDiscount === 0 ? c.amount * c.sellPrice : (c.amount * c.sellPrice) - (c.amount * c.sellPrice) * (c.priceDiscount / 100)).reduce((a, b) => a + b, 0)
                        return total
                    }
                },
                addPrice ? {
                    text: this.$t('headers.amount-received'),
                    name: 'amountReceived',
                    value: 'amountReceived'
                } : null,
                {
                    text: this.$t('headers.remaining'),
                    name: 'remaining',
                    value: 'remaining'
                },
                {
                    text: '',
                    name: 'action',
                    value: 'action'
                }
            ]
            return headers.filter(c => c !== null)
        },

        headersDialog () {
            return [
                {
                    text: this.$t('headers.material-name'),
                    name: 'materialId',
                    value: 'materialId',
                    setValueExpr: val => this.getMaterialBriefById(val)?.name
                },
                {
					text: this.$t('headers.amount'),
					name: 'amount',
					value: 'amount'
				},
                {
					text: this.$t('headers.free'),
					name: 'freeSample',
					value: 'freeSample',
					sortable: false
				},
				{
					text: this.$t('headers.price'),
					name: 'sellPrice',
					value: 'sellPrice',
					width: '15%'
				},
                {
					text: this.$t('headers.discount'),
					name: 'priceDiscount',
					value: 'priceDiscount',
                    noNotAvailableText: true,
					type: 'number'
				},
                {
					text: this.$t('headers.total'),
					name: 'total',
                    value: 'total',
					width: '15%',
					sortable: false
				}
            ]
        },

        isAllFieldsEmpty () {
            return (
                !this.employeeId && this.regionIds.length === 0 && !this.entityIds.length && !this.startDate && !this.endDate && this.entityTypeId === null 
            )
        },
    },

    methods: {
        moment,
        disableDates,

        filter (newOptionsScroll) {
            this.loading = true;
            let page = 1;

            if (newOptionsScroll) {
                page = newOptionsScroll.page;
            }

            this.$store.dispatch('visits/fetchDebtVisits', {
                fromDate: this.dateType === 1 ? this.date : this.startDate,
                toDate: this.dateType === 1 ? this.date : this.endDate,
                entityIds: this.entityIds,
                regionIds: this.regionIds,
                page: page,
                perPage: 20,
                employeeId: this.employeeId
            }).then(({ data, total }) => {
                if (this.needToRestShownItems) {
                    this.$refs.table.resetShownRows();
                    this.needToRestShownItems = false;
                }
                this.$refs.table.addScrollItems(data);
                this.serverItemsLength = total
            }).finally(() => {
                this.loading = false
            })
        },
        clearFilter(){
            // clear fields
            this.employeeId = null;
            this.cityId = [];
            this.regionIds = [];
            this.entityTypeId = [];
            this.entityIds = [];
            this.startDate = this.moment().startOf('month').format('YYYY-MM-DD');
            this.endDate = this.moment().format('YYYY-MM-DD');
            this.date = this.moment().format('YYYY-MM-DD');
            this.isFiltered = false
        },
        setRegions () {
            this.regionIds = [];
            if (!this.cityId) return;
            this.regionsAll.forEach(region => {
                if (this.cityId.includes(region.cityId)) {
                    this.regionIds.push(region.id);
                }
            });
            if (this.regionIds.length) {
                this.loadingMedicalForRegion = true
                this.$store.dispatch('medicalreps/fetchAllBrief', { regionIds: this.regionIds }).then((data) => {
                    this.medicalRepsForRegion = data
                }).finally(() => {
                    this.loadingMedicalForRegion = false
                })
            }
        },

        getMedical() {
            if (this.regionIds.length) {
                this.loadingMedicalForRegion = true
                this.medicalRepIds = []
                this.$store.dispatch('medicalreps/fetchAllBrief', { regionIds: this.regionIds }).then((data) => {
                    this.medicalRepsForRegion = data
                }).finally(() => {
                    this.loadingMedicalForRegion = false
                })
            }
        },

        toggle () {
            this.$nextTick(() => {
                if (this.selectedAllRegions) {
                    this.regionIds = []
                } 
                else {
                    this.regionIds = []
                    this.regionIds = this.regionsAll.filter(c => this.cityId.includes(c.cityId)).map(c => c.id);
                }
            })
        },

        fetchRegionsDueCity(){
            // this.entityIds = [];
            // this.selections.entities = [];
            this.regionIds = [];
            if (!this.cityId) return;

            this.regionIds = [];
            this.regionsAll.forEach(region => {
                if (this.cityId.includes(region.cityId)) {
                    this.regionIds.push(region.id);
                }
            });

            // this.selections.entities = [];
            // if (this.regionIds.length === 0) return/;

            // this.entityLoading = true;
            // this.getEntityForType()
        },

        toggleCities () {
            this.$nextTick(() => {
                if (this.selectedAllCities) {
                    this.cityId = []
                    this.regionIds = []
                } 
                else {
                    this.cityId = this.cities.map(c => c.id);
                    this.fetchRegionsDueCity()
                }
            })
        },

        addDate () {
            this.date = moment(this.date).add(1, 'day').format('YYYY-MM-DD');
            if (
                (this.moment(this.date).format('dddd') === 'Friday' && this.isDisabledFriday) ||
                (this.enableVacations && this.vacationsDayDetails.includes(this.date))
            ) {
                this.addDate()
            }
            return this.date
        },

        subDate() {
            this.date = moment(this.date).subtract(1, 'day').format('YYYY-MM-DD')
            if (
                (this.moment(this.date).format('dddd') === 'Friday' && this.isDisabledFriday) || 
                (this.enableVacations && this.vacationsDayDetails.includes(this.date))
            ) {
                this.subDate()
            }
            return this.date
        },

        submit () {
            // we have tow step 
            // one step (update amountReceived)
            if (!this.$refs.form.validate()) return;
            this.submitLoading = true
            this.$store.dispatch('visits/updateAmountReceived', {
                id: this.visit.id,
                newAmount: this.visit?.amountReceived ? this.visit?.amountReceived + this.amountReceived : this.amountReceived,
            }).then(() => {
                const amountReceived = this.visit?.amountReceived ? this.visit?.amountReceived + this.amountReceived : this.amountReceived
                // two step (update paymentMethods)
                if (amountReceived === this.total) {
                    this.$store.dispatch('visits/updatePaymentMethod', {
                        id: this.visit.id,
                        paymentType: 1,
                    }).finally(() => {
                        this.submitLoading = false
                        this.dialog = false
                    })
                } else {
                    this.submitLoading = false
                    this.dialog = false
                }
                this.needToRestShownItems = true
                this.filter()
            }).finally(() => {
                this.submitLoading = false
            })
        },

        getEntityByType () {
            this.entityLoading = true
           	this.$store.dispatch('entities/fetchAllBrief', { 
				typeId: this.entityTypeId, 
				regionIds: this.regionIds,
				preventStoreEntities: true
			}).then((data) => {
                this.customersFilter = data 
            }).finally(() => {
                this.entityLoading = false
            })
        }
    },

    created () {
        Promise.all([
            !this.regionsAll.length ? this.$store.dispatch('regions/fetchAllRegions', {}) : null,

            enableVacations && !this.vacationsDayDetails.length ? this.$requestStack.setRequest({
                key: 'vacations/fetchAll',
                promise: this.$store.dispatch('vacations/fetchAll'),
            }) : this.$requestStack.getRequest('vacations/fetchAll').promise,

            !this.staff.length ? this.$requestStack.setRequest({
                key: 'accounts/fetchAllBrief/2',
                promise: this.$store.dispatch('accounts/fetchAllBrief', { 
                    type: 0, includeAddress: true, regionIds: []
                }),
            }) : this.$requestStack.getRequest('accounts/fetchAllBrief/2').promise,

            !this.materialBrief.length ? this.$store.dispatch('materials/fetchBrief', {}) : null,

            !this.customersTypes.length ? this.$store.dispatch('entityType/fetchAll') : null,

        ])
        this.filter()
    }
}
</script>
